import type { PermitTypeDto } from "../../types";

export const getDefaultVehicleState = ({ permitType }: { permitType: PermitTypeDto }) => {
	const firstLocation = permitType.wizardSettings.choices?.[0]?.locations[0];
	return firstLocation?.state ?? firstLocation?.lot?.state ?? permitType.company.address?.state ?? "";
};
